/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-06-23 14:32:35
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyUser from "../BsyUser";

export default class BsyUserGroup extends BsyUser {
  static defaultProps = {
    baseCls: "bsy-user bsy-user-group",
    width: 720,
    height: 80,
    value: [],
    type: "usergroup",
  };

  constructor(props) {
    super(props);
    this.state = {
      title: React.language("widget.user.listTitle"),
      msg: React.language("widget.user.clickToSelect1"),
      waterMark: React.language("content.empty"),
      ...props,
      value: this.getValueIds(props.value),
    };
    this.value = this.getValueIds(props.value);
  }

  listMemberName = () => {
    const { value, ftoken } = this.state;
    if (ftoken) {
      return;
    }
    let that = this;
    if (BsyUtils.isObjectEmpty(value)) {
      return;
    }
    let tmpval = [];
    let s = [];
    BsyUtils.forEach(value, (a, b) => {
      tmpval.push(b);
      if (window.userSelectMap[b]) {
        return;
      }
      s.push(b);
    });

    if (BsyUtils.isObjectEmpty(s)) {
      that.setState({ value: tmpval });
      return;
    }

    React.axios("/corp/list_member_name", {
      members: s,
    })
      .then((res) => {
        let a = res.data;
        let d = [];
        if (a.virtually && a.virtually.length > 0) {
          BsyUtils.forEach(a.virtually, function (k, z) {
            switch (z.mode) {
              case "role":
                a.roles || (a.roles = []);
                a.roles.push(z);
                break;
              case "outsider":
                a.outsiderMember || (a.outsiderMember = []);
                a.outsiderMember.push(z);
                break;
              case "member":
                a.users || (a.users = []);
                a.users.push(z);
                break;
              case "outsiderGroup":
                a.outsiderGroup || (a.outsiderGroup = []);
                a.outsiderGroup.push(z);
                break;
              case "current":
              case "currentSub":
                a.job_title || (a.job_title = []);
                a.job_title.push(z);
                break;
              case "relationUser":
                a.userRelation || (a.userRelation = []);
                a.userRelation.push(z);
                break;
              case "relationDept":
                a.deptRelation || (a.deptRelation = []);
                a.deptRelation.push(z);
                break;
              case "deptSub":
              case "dept":
                a.departments || (a.departments = []);
                a.departments.push(z);
            }
          });
        }
        BsyUtils.forEach(a.users, function (a, b) {
          d.push({
            id: b._id,
            avatarurl: b.avatarurl,
            name: BsyUtils._toDeptUser(b, "user"),
            type: "user",
          });
        });
        BsyUtils.forEach(a.dockuser, function (a, b) {
          d.push({
            id: b._id,
            avatarurl: b.avatarurl,
            name: BsyUtils._toDeptUser(b, "user"),
            type: "dockuser",
          });
        });
        BsyUtils.forEach(a.outsiderMember, function (a, b) {
          d.push({
            id: b._id,
            avatarurl: b.avatarurl,
            name: BsyUtils._toDeptUser(b, "outsiderMember"),
            type: "outsiderMember",
          });
        });
        let items = d.concat(that._getDynamicFields());
        BsyUtils.forEach(items, function (t, i) {
          i && (window.userSelectMap[i.id] = window.userSelectMap[i.id] || i);
        });
        that.setState({ value: tmpval });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  getValue = () => {
    return this.value;
  };

  getValueId = (a) => {
    let ftoken = window.FX.STATIC.FTOKEN;

    if (!a) {
      return null;
    }
    let id = a;

    if (ftoken) {
      if (a.hasOwnProperty("_id") || a.hasOwnProperty("id")) {
        id = a._id || a.id;
      }
      return id;
    }

    window.userSelectMap = window.userSelectMap || {};
    if (this.value == window.FX.USER_ID.CurrentUser && window.FX.STATIC.user) {
      id = window.FX.STATIC.user
        ? window.FX.STATIC.user.dock_userid
          ? window.FX.STATIC.user.dock_userid
          : window.FX.STATIC.user._id
        : "";
      let name = window.FX.STATIC.user ? window.FX.STATIC.user.nickname : "";
      let avatarurl = window.FX.STATIC.user
        ? window.FX.STATIC.user.avatarurl
        : "";
      window.userSelectMap[id] = window.userSelectMap[id] || {
        id: id,
        avatarurl: avatarurl,
        name: name,
        type: "user",
      };
      window.userSelectMap[id].avatarurl = avatarurl;
    }

    if (a.hasOwnProperty("_id") || a.hasOwnProperty("id")) {
      id = a._id || a.id;
      window.userSelectMap[id] = a;
    }
    return id;
  };

  getValueIds = (b) => {
    let val = [];

    if (Array.isArray(b)) {
      for (let i = 0; i < b.length; i++) {
        let a = b[i];
        if (a === "100000000000000000000001") {
          a = window.FX.STATIC.user ? window.FX.STATIC.user._id : "";
        }
        let id = this.getValueId(a);
        if (id && val.indexOf(id) == -1) {
          val.push(id);
        }
      }
    }
    return (this.value = val);
  };

  setValue = (val) => {
    if (val) {
      if (BsyUtils.isObjectEmpty(val)) {
        val = [];
      }
    }
    this.value = this.getValueIds(val);
    this.setState(
      {
        value: this.value,
      },
      () => {
        this.listMemberName();
      }
    );
  };

  renderBody = () => {
    const { value, islinkQuery, ftoken, msg } = this.state;

    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.usergroup")}
        </div>
      );
    } else {
      return (
        <ul className="select-list" onClick={this.onClick}>
          {!BsyUtils.isObjectEmpty(value) ? (
            value.map((v) => {
              let item = {};
              let bg = {};
              if (v) {
                if (window.userSelectMap && window.userSelectMap[v]) {
                  item = window.userSelectMap[v];
                  if (item && (item.name || item.nickname))
                    bg = BsyUtils.formatUserThumb(item.name || item.nickname);
                }
              }
              if (BsyUtils.isObjectEmpty(item)) {
                item = { id: v };
              }

              return (
                <li className="select-item" id={v}>
                  {item.avatarurl ? (
                    <img
                      className="user-center"
                      alt=""
                      src={item.avatarurl}
                    ></img>
                  ) : BsyUtils.isObjectEmpty(bg) ? (
                    ""
                  ) : (
                    <span
                      className={"table-user-portrait-name color-" + bg.color}
                    >
                      <span>{bg.name[0]}</span>
                    </span>
                  )}
                  <span>{BsyUtils._toDeptUser(item)}</span>
                </li>
              );
            })
          ) : (
            <div className="select-empty">{msg}</div>
          )}
        </ul>
      );
    }
  };

  renderDisablePane = () => {
    const { value, islinkQuery, ftoken, appId, is_dock_form } = this.state;

    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.user")}
        </div>
      );
    }

    let text = [];
    if (!BsyUtils.isObjectEmpty(value)) {
      value.map((v) => {
        let item = window.userSelectMap[v];
        if (item) text.push(BsyUtils._toDeptUser(item));
      });
    }
    if (BsyUtils.isObjectEmpty(text)) {
      return (
        <div
          className="bsy_form_item_disable "
          data-watermark={React.language("content.empty")}
        ></div>
      );
    }
    return (
      <div
        className="bsy_form_item_disable "
        data-watermark={React.language("content.empty")}
      >
        {!BsyUtils.isObjectEmpty(value) ? (
          <ul className="select-list">
            {" "}
            {value.map((v) => {
              let item = {};
              let bg = {};
              if (v) {
                if (window.userSelectMap && window.userSelectMap[v]) {
                  item = window.userSelectMap[v];
                  if (item && (item.name || item.nickname))
                    bg = BsyUtils.formatUserThumb(item.name || item.nickname);
                }
              }
              if (BsyUtils.isObjectEmpty(item)) {
                item = { id: v };
              }
              return (
                <li
                  className="select-item"
                  id={v}
                  onClick={(e) => {
                    BsyUtils.showUserInfo(null, item, e, appId, is_dock_form);
                  }}
                >
                  {item.avatarurl ? (
                    <img
                      className="user-center"
                      alt=""
                      src={item.avatarurl}
                    ></img>
                  ) : BsyUtils.isObjectEmpty(bg) ? (
                    ""
                  ) : (
                    <span
                      className={"table-user-portrait-name color-" + bg.color}
                    >
                      <span>{bg.name[0]}</span>
                    </span>
                  )}
                  <span>{BsyUtils._toDeptUser(item)}</span>
                </li>
              );
            })}
          </ul>
        ) : (
          ""
        )}
      </div>
    );
  };

  render() {
    const { cssName, css } = this.options;

    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }

    return (
      <div className={cssName} style={css} ref={this.element}>
        {this.renderBody()}
      </div>
    );
  }
}
